export default __webpack_public_path__ + "static/Euclid Circular A Regular-d54600880dc63db716f231e546ff669e.ttf";